import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Record } from '../../models/record/record.class';

@Component({
    selector: 'entity-search-filter',
    templateUrl: './entity-search-filter.component.html',
    styleUrls: ['./entity-search-filter.component.scss'],
    standalone: false,
})
export class EntitySearchFilter implements OnInit, OnDestroy {
    @Input() columnName: string;
    @Input() record: Record;
    @Output() onSearch = new EventEmitter();
    @Input() showError: boolean;

    public fieldId: string;

    ngOnInit() {
        this.fieldId = this.record.getFieldByFieldName(this.columnName)?.id || this.columnName;
    }

    ngOnDestroy() {}
}
